import { DegressiveValue } from '..';
import { Factory } from '../interface/factory';


export enum OwnershipType {
  IncludedInPackage = 'IncludedInPackage',
  Rented = 'Rented',
  Purchased = 'Purchased',
}

// Base abstract class
export class AddonOwnership {
  type: OwnershipType;

  constructor(json: any) {
    this.type = json.type;
  }

  public static getFactory(): Factory<AddonOwnership> {
    return new (class implements Factory<AddonOwnership> {
      make(json: any): AddonOwnership {
        switch (json.type) {
          case OwnershipType.IncludedInPackage:
            return new IncludedInPackageOwnership(json);
          case OwnershipType.Rented:
            return new RentedOwnership(json);
          case OwnershipType.Purchased:
            return new PurchasedOwnership(json);
          default:
            throw new Error('Unrecognized ownership type (' + json.type + ').');
        }
      }

      getTableName(): string {
        throw new Error('Addon Ownerships are never stored in IndexedDB');
      }
    })();
  }
}

// Simple case - no additional properties
export class IncludedInPackageOwnership extends AddonOwnership {
  constructor(json: any) {
    super(json);
  }
}

// Purchased case with associated data
export class PurchasedOwnership extends AddonOwnership {
  date: Date;
  paymentSpecificationId: string;

  constructor(json: any) {
    super(json);
    this.date = new Date(json.date);
    this.paymentSpecificationId = json.paymentSpecificationId;
  }
}

// Rented case with associated data
export class RentedOwnership extends AddonOwnership {
  start: Date;
  degressiveValue: DegressiveValue;
  endCost?: number;
  end?: Date;

  constructor(json: any) {
    super(json);
    this.start = new Date(json.start);
    this.degressiveValue = new DegressiveValue(json.degressiveValue);
    this.endCost = json.endCost ? Number(json.endCost) : undefined;
    this.end = json.end ? new Date(json.end) : undefined;
  }
}
